<app-hero [text]="hero_1" [template]="'hero-1'" [functionsMap]="functionsMap"></app-hero>
<app-hero [text]="hero_2" [template]="'hero-2'" [functionsMap]="functionsMap"></app-hero>
<app-hero [text]="hero_3" [template]="'hero-3'" [functionsMap]="functionsMap"></app-hero>

@if(platform === 'web') {
<div class="flex flex-wrap download_app p-2 md:p-8">
  <div class="md:col-6 col-12 align-items-center flex">
    <div>
      <h2>{{ downloadApp.title }}</h2>
      <p class="mb-4">
        {{ downloadApp.description }}
      </p>
      <a href="https://play.google.com/store/apps/details?id=com.apprezzoo" target="_blank">
        <img src="assets/images/play-store.svg" alt="Logo" class="mobile-icon" />
      </a>
      <a href="https://apps.apple.com/it/app/apprezzoo/id6744108858" target="_blank">
        <img src="assets/images/apple-store.svg" alt="Logo" class="mobile-icon" />
      </a>
    </div>
  </div>
  <div class="md:col-6 col-12 text-center p-8">
    <img
      src="../assets/images/APPLE-screen_ricerca.png"
      style="max-width: 500px"
      alt=""
      class="w-full md:max-w-30rem" />
  </div>
</div>
}
<div
  class="px-4 py-8 md:px-6 lg:px-8"
  style="
    background: radial-gradient(
      69.84% 69.84% at 50% 100%,
      rgb(132 255 217 / 15%) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  ">
  <div class="text-900 text-3xl font-bold mb-3 text-center">{{ ourValues.title }}</div>

  <div class="grid mt-7">
    <div class="col-12 md:col-4">
      <div class="shadow-1 p-5 surface-card text-center border-round h-full">
        <div
          class="border-circle p-4 bg-primary inline-flex justify-content-center align-items-center mb-4">
          <i class="pi pi-bolt text-5xl"></i>
        </div>
        <div class="text-900 font-medium text-2xl mb-4">{{ ourValues.values.speed.title }}</div>
        <div class="text-700 mb-4 line-height-3">
          {{ ourValues.values.speed.description }}
        </div>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div class="shadow-1 p-5 surface-card text-center border-round h-full">
        <div
          class="border-circle p-4 bg-primary inline-flex justify-content-center align-items-center mb-4">
          <i class="pi pi-euro text-5xl"></i>
        </div>
        <div class="text-900 font-medium text-2xl mb-4">{{ ourValues.values.savings.title }}</div>
        <div class="text-700 mb-4 line-height-3">{{ ourValues.values.savings.description }}</div>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div class="shadow-1 p-5 surface-card text-center border-round h-full">
        <div
          class="border-circle p-4 bg-primary inline-flex justify-content-center align-items-center mb-4">
          <i class="pi pi-sync text-5xl"></i>
        </div>
        <div class="text-900 font-medium text-2xl mb-4">
          {{ ourValues.values.sustainability.title }}
        </div>
        <div class="text-700 mb-4 line-height-3">
          {{ ourValues.values.sustainability.description }}
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="!(isLoggedIn$ | async)">
  <div
    class="relative lg:p-8 p-6 text-0 overflow-hidden"
    style="
      background: url('assets/images/bg_hero_login.jpg'),
        linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)) no-repeat;
      background-size: cover;
      background-blend-mode: darken;
    ">
    <app-hero
      [text]="hero_registrati"
      [template]="'hero-registration'"
      [functionsMap]="functionsMap"></app-hero>
  </div>
</ng-container>
